import { QuestionPlanPreQuestions as Question } from "@/components/features/items/edit/plan/_shared/ui/components/pre-questions/pre-questions";

import { usePlanPreQuestions } from "./hooks/use-pre-questions";

export const QuestionPlanPreQuestions = () => {
	const {
		appendQuestion,
		removeQuestion,
		reorderQuestions,
		questions,
		onSetIsRequired,
		onSetQuestionType,
		onSetTitle,
		appendOptionItem,
		removeOptionItem,
		onSetOptionItem,
	} = usePlanPreQuestions();

	return (
		<Question
			questions={questions}
			appendQuestion={appendQuestion}
			removeQuestion={removeQuestion}
			reorderQuestions={reorderQuestions}
			onSetIsRequired={onSetIsRequired}
			onSetQuestionType={onSetQuestionType}
			onSetTitle={onSetTitle}
			appendOptionItem={appendOptionItem}
			removeOptionItem={removeOptionItem}
			onSetOptionItem={onSetOptionItem}
		/>
	);
};

QuestionPlanPreQuestions.displayName = "QuestionPlanPreQuestions";
